// extracted by mini-css-extract-plugin
export default {"box":"Box_box__dH1v1","icon":"Box_icon__QuLZF","text":"Box_text__im9aQ","title":"Box_title__+sqEJ","description":"Box_description__i7gPc"};